import { AcuityScoreBadge } from "@/features/acuity/components/AcuityScoreBadge";
import type { CurrentAcuityScoreResponse } from "@/core/types";

import { getFormattedAcuityDate } from "../helpers/getFormattedAcuityDate";
import { PatientData } from "../../components/PatientData";

type EffectiveAcuityIndexProps = {
  effective_score: CurrentAcuityScoreResponse["effective_score"];
};

export function EffectiveAcuityIndex({ effective_score }: EffectiveAcuityIndexProps) {
  const { score, updated_at } = effective_score || {};

  return (
    <>
      <PatientData
        className="tw:flex tw:items-baseline"
        classNameChildren="tw:flex"
        label="Acuity Index"
      >
        <AcuityScoreBadge acuityScore={score} />
      </PatientData>

      {score && <Label timestamp={updated_at} />}
    </>
  );
}

function Label({ timestamp }: { timestamp: string }) {
  const formattedDate = getFormattedAcuityDate(timestamp);

  return (
    <PatientData className="tw:text-sm tw:text-text-tertiary tw:*:font-normal" label="Updated">
      {formattedDate}
    </PatientData>
  );
}
